/**
 * Minimal theme preset
 * Clean, modern, and professional with neutral colors
 */

import { ThemeSchema, type Theme } from '../types';
import { DEFAULT_DENSITY } from './base';

export const minimalTheme: Theme = ThemeSchema.parse({
  name: 'minimal',
  colors: {
    primary: '#1a1a1a',
    primaryDark: '#000000',
    primaryLight: '#333333',
    accent: '#0066cc',
    accentDark: '#004d99',
    accentLight: '#3399ff',
    background: '#ffffff',
    backgroundAlt: '#f5f5f5',
    surface: '#ffffff',
    text: '#1a1a1a',
    textMuted: '#666666',
    textInverse: '#ffffff',
    border: '#e0e0e0',
    success: '#16a34a',
    warning: '#a16207',
    error: '#ef4444',
    // Medical-specific
    evidenceStrong: '#0C7A53',
    evidenceModerate: '#B45309',
    evidenceLow: '#6b7280',
    safetyWarning: '#ef4444',
    safetyInfo: '#3b82f6',
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontFamilyHeading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeightHeading: '700',
    fontSizeBase: '1rem',
    fontSizeSm: '0.875rem',
    fontSizeLg: '1.125rem',
    fontSizeXl: '1.25rem',
    fontSize2xl: '1.5rem',
    fontSize3xl: '1.875rem',
    fontSize4xl: '2.25rem',
    lineHeightBase: '1.5',
    lineHeightTight: '1.25',
    lineHeightLoose: '1.75',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  // HAL-495: shared layout rhythm + ch-based reading measures. See DEFAULT_DENSITY.
  density: DEFAULT_DENSITY,
});
